import cls from 'classnames';
import usePrice from '../../hooks/usePrice';
import useFormat from '../../hooks/useFormat';

const ProductPrices = ({ quantity, productVariation }) => {
    
    const { formatPrice } = useFormat();
    const { productPrice } = usePrice({
        product: productVariation,
        quantity: quantity,
    });
    const { linePrice, originalLinePrice, priceType } = productPrice;

    return (
        <>            
            <div className="flex flex-shrink-0 flex-grow-0 flex-col justify-center">
                <div
                    className={cls('font-bold', {
                        'text-black': priceType !== 'special',
                        'text-yellow': priceType === 'special',
                    })}
                >
                    {priceType === 'special' && (
                        <span className="relative -top-0.5 pr-2 text-md font-normal text-dark md:text-base ">
                            For you
                        </span>
                    )}
                    <b>{formatPrice(linePrice)}</b>
                </div>
            </div>
            {originalLinePrice && (
                <div className="flex flex-shrink-0 flex-grow-0 justify-end text-md text-dark-grey line-through md:text-base">
                    <b>{formatPrice(originalLinePrice)}</b>
                </div>
            )}    
        </>
    );
};

export default ProductPrices;
